import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { Bank } from '@core/model/domain/bank';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  standalone: true,
  imports: [FormsModule, TranslateModule],
})
export class BankComponent {
  @Input() banks!: Bank[];

  constructor(
    private readonly processEventService: ProcessEventService,
    private readonly tracker: TrackerService
  ) {}

  selectBank(bank: Bank) {
    this.tracker.trackClick({ click: bank.name, taggingPage: 'BANK_CHOICE' });
    this.processEventService.push(ProcessEventFactory.SpawnBankChoiceEvent(bank));
  }
}
